import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, KeyRound, Loader2, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { useLang, CONTACT_EMAIL } from "./i18n";
import { Eyebrow, Reveal, useSeo } from "./bits";

const Shell = ({ children, testid }) => (
  <div className="pt-[calc(72px+env(safe-area-inset-top))] bg-[#7CC6FA] min-h-[80vh]" data-testid={testid}>
    <div className="max-w-[860px] mx-auto px-5 sm:px-8 py-12 sm:py-20">{children}</div>
  </div>
);

export function AreaClientiPage() {
  const { t, lang } = useLang();
  const a = t.area;
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");
  useSeo(`${a.title} – Core`, a.p1);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setState("sending");
    try { await api.post("/public/richiesta-link-portale", { email, lingua: lang, website: hp }); setState("ok"); }
    catch (ex) { setState("idle"); setErr(ex?.response?.data?.detail && ex.response.status === 429 ? ex.response.data.detail : t.contatti.err); }
  };
  return (
    <Shell testid="area-clienti-page">
      <Reveal><Eyebrow>{a.eyebrow}</Eyebrow><h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">{a.title}</h1></Reveal>
      <Reveal delay={100} className="mt-6 space-y-4 text-base sm:text-lg text-[#0A1128]/85 leading-relaxed"><p>{a.p1}</p><p>{a.p2}</p></Reveal>
      <Reveal delay={180} className="mt-10 rounded-[28px] bg-white p-6 sm:p-8 shadow-[0_18px_50px_rgba(10,17,40,0.10)]">
        <div className="flex items-center gap-3"><div className="h-11 w-11 rounded-2xl bg-[#E8173A] text-white flex items-center justify-center"><KeyRound className="h-5 w-5" /></div><h2 className="font-display text-xl font-black">{a.lost}</h2></div>
        <p className="mt-2 text-sm text-slate-600">{a.lostSub}</p>
        {state === "ok" ? (
          <div className="mt-5 rounded-2xl bg-emerald-50 border border-emerald-200 px-4 py-3 text-sm font-bold text-emerald-800 flex items-center gap-2" data-testid="area-clienti-ok"><Check className="h-4 w-4" />{a.ok}</div>
        ) : (
          <form onSubmit={submit} className="mt-5 flex flex-col sm:flex-row gap-3" data-testid="area-clienti-form">
            <input type="text" value={hp} onChange={(e) => setHp(e.target.value)} tabIndex={-1} autoComplete="off" aria-hidden className="absolute -left-[9999px] h-0 w-0 opacity-0" />
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@azienda.it" autoComplete="email"
              className="flex-1 h-12 rounded-2xl border border-[#0A1128]/12 px-4 text-base focus:outline-none focus:ring-2 focus:ring-[#E8173A]/40" data-testid="area-clienti-email" />
            <button disabled={state === "sending"} className="h-12 px-6 rounded-full bg-[#0A1128] hover:bg-[#E8173A] text-white font-bold inline-flex items-center justify-center gap-2 transition-colors" data-testid="area-clienti-submit">
              {state === "sending" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}{a.send}
            </button>
          </form>
        )}
        {err && <div className="mt-3 text-sm font-semibold text-[#C8102E]" data-testid="area-clienti-error">{err}</div>}
      </Reveal>
      <Link to="/" className="mt-8 inline-block font-bold text-[#0A1128] hover:text-[#E8173A]" data-testid="area-clienti-back">← {a.back}</Link>
    </Shell>
  );
}

export function PrivacyPage() {
  const { t } = useLang();
  useSeo(`${t.privacy.title} – Core`, t.privacy.body[1]);
  return (
    <Shell testid="privacy-page">
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">{t.privacy.title}</h1>
      <div className="mt-8 rounded-[28px] bg-white p-6 sm:p-10 space-y-4 text-[15px] leading-relaxed text-slate-700">
        {t.privacy.body.map((p, i) => <p key={i}>{p}</p>)}
        <p className="font-bold text-[#0A1128]">Email: <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#E8173A]">{CONTACT_EMAIL}</a></p>
      </div>
    </Shell>
  );
}
